import React, { useEffect, useMemo, useState } from "react"
import { getPMCompaniesApi, getPMStagesApi } from '@/services';
import { useRequest } from 'ahooks';
import { Select, ConfigProvider } from "antd"
import clsx from "clsx";

interface RenderDept{
    deptCode: string
    deptName: string
}
interface RenderCompany{
    companyCode: string
    companyName: string,
    depts: RenderDept[]
}
interface BusinessType{
    businessType: string
    businessTypeCnName: string
}
interface ProjectType {
    projectCategory: string
    projectCategoryCnName: string
}
interface BigStage{
    projectBigStage: string
    projectBigStageCnName: string
}
interface Level2Option extends ProjectType {
    childs: BigStage[]
}
interface Level1Option extends BusinessType {
    childs: Level2Option[]
}
const handleTypeData = (flatData: API.PROJECT.TypeStage[]) => {
    if(!flatData) return []
    const list: Level1Option[] = []
    flatData.forEach(item => {
        // 处理第一级
        const item1 = list.find(v => v.businessType === item.businessType)
        if (!item1) {
            list.push({
                businessType: item.businessType,
                businessTypeCnName: item.businessTypeCnName,
                childs: [{
                    projectCategory: item.projectCategory,
                    projectCategoryCnName: item.projectCategoryCnName,
                    childs: [{
                        projectBigStage: item.projectBigStage,
                        projectBigStageCnName: item.projectBigStageCnName
                    }]
                }]
            })
            return
        }
        
        // 处理第二级
        const item2 = item1.childs.find(v => v.projectCategory === item.projectCategory)
        if (!item2) {
            item1.childs.push({
                projectCategory: item.projectCategory,
                projectCategoryCnName: item.projectCategoryCnName,
                childs: [{
                    projectBigStage: item.projectBigStage,
                    projectBigStageCnName: item.projectBigStageCnName
                }]
            })
            return
        }

        // 处理第三级
        const item3 = item2.childs.find(v => v.projectBigStage === item.projectBigStage)
        if (!item3) {
            item2.childs.push({
                projectBigStage: item.projectBigStage,
                projectBigStageCnName: item.projectBigStageCnName
            })
        }
        
    });

    return list;
}
export interface IFilterParams{
    businessType: string,
    projectCategory: string,
    projectBigStage: string,
    companyCode: string,
    deptCode: string,
    keyword: string,
    isFollow: boolean
}
interface IProps{
    onChange: (v: IFilterParams) => void
}
const ProjectHeader: React.FC<IProps> = (props) => {
    const emitChange = () => {
        props.onChange({
            businessType: level1?.businessType || "",
            projectCategory: level2?.projectCategory || "",
            projectBigStage: level3?.projectBigStage || "",
            companyCode: company?.companyCode || "",
            deptCode: dept?.deptCode || "",
            keyword: searchText,
            isFollow: isFollow
        })
    }
    const [isFollow, setIsFollow] = useState(false)
    const onFollowChange = () => {
        setIsFollow((v)=>(!v))
    }
    //---------搜索--------
    const [searchText, setSearchText] = useState("")
    const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            emitChange()
        }
    }

    //---------公司部门切换--------
    const [company, setCompany] = useState<RenderCompany>()
    const [dept, setDept] = useState<RenderDept>()
    const [companyOptions, setCompanyOptions] = useState<RenderCompany[]>([])
    useRequest(getPMCompaniesApi, {
        onSuccess: (data) => {
            if (!data) return
            const list: RenderCompany[] = []
            data.forEach(v => {
                const company = list.find(item => v.companyCode === item.companyCode)
                if (!company) {
                    list.push({
                        companyCode: v.companyCode,
                        companyName: v.companyName,
                        depts: [{ deptCode: v.deptCode, deptName: v.deptName}]
                    })
                } else {
                    company.depts.push({ deptCode: v.deptCode, deptName: v.deptName })
                }
            })
            setCompanyOptions(list)
            if(list.length <= 0) return
            const initItem = list[0]
            setCompany(initItem)
            setDept(initItem.depts[0])
        }
    })
    const onCompanyChange = (code?: string) => {
        if (!code) {
            setCompany(undefined)
            setDept(undefined)
            return
        }
        const item = companyOptions.find(v => v.companyCode === code)
        setCompany(item)
        // setDept(item?.depts[0])
        setDept(undefined)
    }
    const onDeptChange = (code?: string) => {
        if (!code) {
            setDept(undefined)
            return
        }
        const depts = company?.depts
        if (!depts) return
        const item = depts.find(v => v.deptCode === code)
        setDept(item)
    }


    //---------类型切换--------
    const [typeOptions, setTypeOptions] = useState<Level1Option[]>([])
    const [level1, setLevel1] = useState<Level1Option>()
    const [level2, setLevel2] = useState<Level2Option>()
    const [level3, setLevel3] = useState<BigStage>()
    useRequest(getPMStagesApi, {
        onSuccess: (data) => {
            const opts = handleTypeData(data)
            setTypeOptions(opts)

            // if (opts.length <= 0) return
            // const l1 = opts[0]
            // setLevel1(l1)
            // if (l1.childs.length <= 0) return
            // const l2 = l1.childs[0]
            // setLevel2(l2)
            // if (l2.childs.length <= 0) return
            // setLevel3(l2.childs[0])

        }
    })
    const onL1Change = (code?: string) => {
        if (!code) {
            setLevel1(undefined)
            setLevel2(undefined)
            setLevel3(undefined)
            return
        }
        const l1 = typeOptions.find(v => v.businessType === code)
        if (!l1) return
        setLevel1(l1)
        setLevel2(undefined)
        setLevel3(undefined)
        // if (l1.childs.length <= 0) return
        // const l2 = l1.childs[0]
        // setLevel2(l2)
        // if (l2.childs.length <= 0) return
        // setLevel3(l2.childs[0])
    }
    const onL2Change = (code?: string) => {
        if (!code) {
            setLevel2(undefined)
            setLevel3(undefined)
            return
        }
        const l2 = level1?.childs.find(v => v.projectCategory === code)
        if (!l2) return
        setLevel2(l2)
        setLevel3(undefined)
        // if (l2.childs.length <= 0) return
        // setLevel3(l2.childs[0])
    }
    const onL3Change = (code?: string) => {
        if (!code) {
            setLevel3(undefined)
            return
        }
        const l3 = level2?.childs.find(v => v.projectBigStage === code)
        if (!l3) return
        setLevel3(l3)
    }
    const [clearEffect, setClearEffect] = useState(false)
    useEffect(() => {
        emitChange()
    }, [level1, level2, level3, company, dept, isFollow, clearEffect])
    const isAll = useMemo(() => {
        if (searchText || level1 || level2 || level3 || company || dept || isFollow) return false
        return true
    }, [searchText, level1, level2, level3, company, dept, isFollow])
    const onClear = () => {
        setSearchText("")
        setIsFollow(false)
        setLevel1(undefined)
        setLevel2(undefined)
        setLevel3(undefined)
        setCompany(undefined)
        setDept(undefined)
        setClearEffect((v)=>(!v))
    }
    return (
        <ConfigProvider
            theme={{
                token: {
                    borderRadius: 2
                },
            }}
        >

            <div className='relative 2xl:flex items-end justify-between gap-8 bg-white pb-4'>
                <div className="flex items-center justify-between">
                    <div className="flex items-center h-[35px] border border-solid border-gray-400 rounded-[2px] overflow-hidden">
                            <div className={clsx('w-24 h-full text-center leading-[35px] cursor-pointer hover:bg-gray-200', isAll && "bg-gray-300 hover:bg-gray-300")} onClick={onClear}>全部</div>
                        <div className="w-px h-full bg-gray-400"></div>
                            <div className={clsx('w-24 h-full text-center leading-[35px] cursor-pointer hover:bg-gray-200', isFollow && "bg-gray-300 hover:bg-gray-300")} onClick={onFollowChange}>关注</div>
                    </div>
                    <div className='h-[35px] flex justify-end 2xl:hidden'>
                        <input className='2xl:flex-1 h-full border-solid border border-transparent outline-none focus-within:border-gray-400 bg-gray-200 w-60 px-2'
                            type="text"
                            placeholder='请输入项目名称/项目编号/参与人员'
                            value={searchText}
                            onInput={(e) => setSearchText(e.currentTarget.value)}
                            onKeyDown={onKeyDown}
                        />
                        <div className='shrink-0 w-[80px] h-[35px] bg-dark-bg text-white text-center leading-[35px] cursor-pointer' onClick={emitChange}>搜索</div>
                    </div>
                </div>
                <div className="flex items-center justify-center gap-4 mt-4 2xl:mt-0">
                    <div className="flex items-center 2xl:block">
                        <div className='text-sm'>业务类型:</div>
                        <Select
                            value={level1?.businessType}
                            placeholder="请选择业务类型"
                            allowClear
                            style={{ maxWidth: 200 }}
                            styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                            onChange={onL1Change}
                            options={typeOptions.map((v) => (
                                { label: v.businessTypeCnName, value: v.businessType }
                            ))}
                        />
                    </div>
                    <div className="flex items-center 2xl:block">
                        <div className='text-sm'>项目类型:</div>
                        <Select
                            value={level2?.projectCategory}
                            disabled={!level1}
                            allowClear
                            placeholder="请选择项目类型"
                            style={{ maxWidth: 200 }}
                            styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                            onChange={onL2Change}
                            options={level1?.childs.map((v) => (
                                { label: v.projectCategoryCnName, value: v.projectCategory }
                            ))}
                        />
                    </div>
                    <div className="flex items-center 2xl:block">
                        <div className='text-sm'>项目大阶段:</div>
                        <Select
                            value={level3?.projectBigStage}
                            placeholder="请选择项目大阶段"
                            allowClear
                            disabled={!level2}
                            style={{ maxWidth: 200 }}
                            styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                            onChange={onL3Change}
                            options={level2?.childs.map((v) => (
                                { label: v.projectBigStageCnName, value: v.projectBigStage }
                            ))}
                        />
                    </div>
                    <div className="flex items-center 2xl:block">
                        <div className='text-sm'>参与生产公司:</div>
                        <Select
                            value={company?.companyCode}
                            placeholder="请选择参与生产公司"
                            allowClear
                            style={{ maxWidth: 200 }}
                            styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                            onChange={onCompanyChange}
                            options={companyOptions.map((v) => (
                                { label: v.companyName, value: v.companyCode }
                            ))}
                        />
                    </div>
                    <div className="flex items-center 2xl:block">
                        <div className='text-sm'>参与生产部门:</div>
                        <Select
                            value={dept?.deptCode}
                            disabled={!company}
                            allowClear
                            placeholder="请选择参与生产部门"
                            style={{ maxWidth: 200 }}
                            styles={{ popup: { root: { width: "fit-content", minWidth: 150 } } }}
                            onChange={onDeptChange}
                            options={company?.depts.map((v) => (
                                { label: v.deptName, value: v.deptCode }
                            ))}
                        />
                    </div>
                </div>
                <div className='hidden h-[35px] 2xl:flex justify-end '>
                    <input className='2xl:flex-1 h-full border-solid border border-transparent outline-none focus-within:border-gray-400 bg-gray-200 w-60 px-2'
                        type="text"
                        placeholder='请输入项目名称/项目编号/参与人员'
                        value={searchText}
                        onInput={(e) => setSearchText(e.currentTarget.value)}
                        onKeyDown={onKeyDown}
                    />
                    <div className='shrink-0 w-[80px] h-[35px] bg-dark-bg text-white text-center leading-[35px] cursor-pointer' onClick={emitChange}>搜索</div>
                </div>
            </div>
        </ConfigProvider>
    )
}
export default ProjectHeader